<router-outlet></router-outlet>

<!-- Token Expiry Warning Popup -->
@if(showTokenPopup){
<div class="dc-modal">
  <div class="dc-modal-container bg-white min-w-3xs! max-w-[450px]!">
    <div class="text-center">
      <button
        class="modal-x-button"
        type="button"
        (click)="startTokenCountdown(); showTokenPopup = false"
      >
        <i class="fas fa-close"></i>
      </button>

      <h2 class="text-lg font-semibold mb-2">
        {{ "SESSION_EXPIRING" | translate }}
      </h2>
      <p class="mb-4">
        {{
          "SESSION_EXPIRING_TIME"
            | translate
              : { minutes: countdownMinutes, seconds: countdownSeconds }
        }}
      </p>
      <div class="flex justify-center gap-4">
        <app-button
          type="button"
          classesName="btn-edge-cut min-w-30 px-4 py-2"
          [label]="'BUTTONS.REFRESH_NOW' | translate"
          (onBtnClick)="refreshManually()"
        >
        </app-button>

        <app-button
          type="button"
          classesName="card-edge-cut-white min-w-30  px-4 py-2"
          label="Logout"
          [label]="'BUTTONS.LOGOUT' | translate"
          (onBtnClick)="logoutNow()"
        >
        </app-button>
      </div>
    </div>
  </div>
</div>
}

<!-- For the chatboat container -->
<div id="demo"></div>
